<template>
  <div>
    <ui-spinner v-if="loading.view == true"></ui-spinner>
    <div v-else>
      <div class="row form-row">
        <div class="col-lg-3">
          <ValidationObserver ref="form">
            <div class="form-group">
              <label for="" class="form-label">Nombre *</label>
              <InputText v-model="name" name="Nombre" rules="required"></InputText>
            </div>
            <div class="form-group">
              <label for="" class="form-label">Dirección</label>
              <input v-model="direction" type="text" class="form-control form-control-sm" />
            </div>
            <div class="form-group">
              <label for="" class="form-label">RUC</label>
              <div class="form-row">
                <div class="col-10">
                  <InputText v-model="ruc" rules="ruc" name="RUC"></InputText>
                </div>
                <div class="col-2">
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm btn-icon"
                    @click="fetchRucDni"
                    :disabled="loading.rucdni"
                  >
                    <i class="fa fa-fw fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group text-right">
              <button class="btn btn-sm btn-outline-success" :disabled="loading.crud" @click="onNew">
                Nuevo
              </button>
              <button class="ml-2 btn btn-sm btn-primary" :disabled="loading.crud" @click="onSave">
                Guardar
              </button>
            </div>
          </ValidationObserver>
        </div>
        <div class="col-lg-9">
          <Table :rows="containers.restaurantes" :columns="containers.columns" :columnID="'idRestaurante'">
            <template #rowactions="{ row }">
              <template v-if="row.origen != 0">
                <button class="btn btn-xs btn-icon btn-light-warning" @click="onEdit(row)">
                  <span class="fa fa-fw fa-pencil-alt"></span>
                </button>
                <button class="btn btn-xs btn-icon btn-light-danger ml-2" @click="onDelete(row)">
                  <span class="fa fa-fw fa-trash-alt"></span>
                </button>
              </template>
            </template>
          </Table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InputText from "../../../modules/shared/components/InputText.vue";
import Table from "../../../modules/shared/components/Table.vue";
export default {
  components: { Table, InputText },
  layout: "app",
  data() {
    return {
      name: "",
      direction: "",
      ruc: "",
      loading: {
        view: true,
        crud: false,
        rucdni: false,
      },
      containers: {
        id: null,
        restaurantes: [],
        columns: [
          {
            key: "actions",
            label: "",
            width: 60,
          },
          {
            key: "nombre",
            label: "Nombre",
            width: 200,
          },
          {
            key: "ruc",
            label: "RUC",
            width: 150,
          },
          {
            key: "direccion",
            label: "Dirección",
            width: 150,
          },
          {
            key: "usuarioCreador",
            label: "UC",
            head_class: "text-center",
            width: 80,
          },
          {
            key: "usuarioModif",
            label: "UM",
            head_class: "text-center",
            width: 80,
          },
        ],
      },
    };
  },
  async created() {
    const vm = this;

    let {
      data: { content },
    } = await vm.axios.get("/mantenimiento/restaurantes");

    vm.containers.restaurantes = content.restaurantes;

    vm.loading.view = false;
  },
  methods: {
    async onSave() {
      let vm = this;

      const validated = await vm.$refs.form.validate();

      if (!validated) {
        vm.$toast.fire({
          icon: "warning",
          title: "Revise y verifique los campos en rojo",
        });

        return;
      }

      let fd = {
        name: String(vm.name).trim(),
        direction: String(vm.direction || '').trim(),
        ruc: vm.ruc || "",
        _method: "POST",
      };

      vm.loading.crud = true;

      let endpoint = "/mantenimiento/restaurantes";

      if (vm.containers.id) {
        endpoint = `/mantenimiento/restaurantes/${vm.containers.id}`;
        fd._method = "PUT";
      }

      vm.axios
        .post(endpoint, fd)
        .then((response) => {
          if (vm.containers.id) {
            let findRow = vm.containers.restaurantes.find((item) => item.idRestaurante == vm.containers.id);

            findRow.nombre = fd.name;
            findRow.direccion = fd.direction || "";
            findRow.usuarioModif = vm.$store.state.user.codigo;
            findRow.ruc = fd.ruc || "";
          } else {
            vm.containers.restaurantes.push({
              nombre: fd.name,
              direccion: fd.direction || "",
              idRestaurante: response.data.content.id,
              usuarioCreador: vm.$store.state.user.codigo,
              ruc: fd.ruc || "",
            });

            vm.containers.id = response.data.content.id;
          }

          vm.$toast.fire(response.data.message, "", "success");
        })
        .catch((error) => {
          vm.$toast.fire(error.response.data.message, "", "error");
        })
        .finally(() => {
          vm.loading.crud = false;
        });
    },
    onEdit(pItem) {
      let vm = this;
      vm.containers.id = pItem.idRestaurante;
      vm.name = pItem.nombre;
      vm.direction = pItem.direccion == "null" ? "" : pItem.direccion || "";
      vm.ruc = pItem?.ruc || "";
      window.scrollTo(0, 0);
    },
    async onDelete(pItem) {
      let vm = this;
      let response = await vm.$confirm.fire("", "¿Seguro que desea eliminar este item?");

      if (response.value) {
        vm.loading.crud = true;

        vm.axios
          .delete(`/mantenimiento/restaurantes/${pItem.idRestaurante}`)
          .then((response) => {
            let tempRegistros = [...vm.containers.restaurantes];
            vm.containers.restaurantes = tempRegistros.filter((item) => item.idRestaurante != pItem.idRestaurante);
          })
          .catch((error) => {
            vm.$toast.fire(error.response.data.message, "", "error");
          })
          .finally(() => {
            vm.loading.crud = false;
          });
      }
    },
    onNew() {
      let vm = this;
      vm.containers.id = null;
      vm.name = "";
      vm.direction = "";
      vm.ruc = "";
    },
    async fetchRucDni() {
      const vm = this;

      const type = "ruc";
      const number = String(vm.ruc).trim();

      if (!number) {
        vm.$toast.fire({
          icon: "warning",
          title:
            "Ingrese un Número de documento"
        });
        return;
      }

      vm.name = "";
      vm.direction = "";
      vm.loading.rucdni = true;

      try {
        const response = await vm.axios.get("/consulta/rucdni", {
          params: {
            type,
            number
          }
        });

        const { nombre, direccion } = response.data;

        vm.name = nombre;
        vm.direction = direccion;
      } catch (error) {
        console.error({ error: error?.response || error });

        vm.$toast.fire({
          icon: "error",
          title: "Error al consultar los datos del documento"
        });
      } finally {
        vm.loading.rucdni = false;
      }
    }
  },
};
</script>
